<template>
    <div class="tl-row">
        <div class="tl-columnheader">
            <h2 class="tl-tit">공사지 주소 <span class="color-red">*</span></h2>
        </div>
        <div class="tl-cell">
            <div class="form-address">
                <div class="form-address__postcode">
                    <input :value="inputs.postcode" class="input" type="text" readonly placeholder="우편번호" @click="openDaumPostcode" />
                    <button class="button button--primary" @click="openDaumPostcode">검색</button>
                </div>
                <input :value="inputs.address1" class="input" type="text" placeholder="기본세 주소를 입력해주세요." @click="openDaumPostcode" />
                <input :value="inputs.address2" class="input" type="text" placeholder="상세 주소를 입력해주세요." @change="setAddress2" />
            </div>
        </div>
        <daum-postcode ref="daum-postcode" @change="setInputs"></daum-postcode>
    </div>
</template>
<script>
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import getGeolocation from "@/plugins/getGeolocation";

export default {
    components: {
        DaumPostcode,
    },
    props: {
        inputs: {
            postcode: Number,
            address1: String,
            address2: String,
        },
    },
    methods: {
        openDaumPostcode() {
            this.$refs["daum-postcode"].open();
        },
        async setInputs(inputs) {
            const geolocation = await getGeolocation(inputs.address);
            
            console.log(geolocation);
            
            this.$emit("set-input", { postcode: inputs.postcode, address1: inputs.address, geolocation });
        },
        setAddress2(event) {
            this.$emit("set-input", { address2: event.target.value });
        },
    },
};
</script>
